import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PortalMetadata, ThemeProvider } from '@command-center/ui-system';
import { AuthProvider } from './auth';
import { ToastProvider } from './lib';
import { App } from './App';
import { ecorpShellConfig } from './shell.config';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode><BrowserRouter><ThemeProvider defaultTheme="light" colors={ecorpShellConfig.branding.colors}><PortalMetadata branding={ecorpShellConfig.branding} /><ToastProvider><AuthProvider><App /></AuthProvider></ToastProvider></ThemeProvider></BrowserRouter></React.StrictMode>,
);
